/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Issue_Name_LabelInputs */



/**
* | output |
* | --- |
* | "Issue name" |
*
* @param {Manual_Qc_Issue_Name_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_issue_name_label = /** @type {((inputs?: Manual_Qc_Issue_Name_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Issue_Name_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nom de l'incident")
	if (locale === "de") return /** @type {LocalizedString} */ ("Problemname")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nome del problema")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Название проблемы")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nombre del problema")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("问题名称")
	if (locale === "ja") return /** @type {LocalizedString} */ ("問題名")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समस्या का नाम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nome do problema")
	return /** @type {LocalizedString} */ ("Issue name")
});